import { number } from './format'

export type PressureUnit = 'KPA' | 'KGF_CM2'

export const KGF_CM2_PER_KPA = 0.01019716213

export const pressureUnitLabel: Record<PressureUnit, string> = {
  KPA: 'кПа',
  KGF_CM2: 'кгс/см²',
}

export function convertPressure(valueKpa: number, unit: PressureUnit): number {
  return unit === 'KPA' ? valueKpa : valueKpa * KGF_CM2_PER_KPA
}

/**
 * Converts pressure to force for a sensing pad with a known effective area.
 * 1 kPa over 1 cm² = 0.01019716213 kilogram-force.
 */
export function convertPressureToForceKgf(valueKpa: number, sensorAreaCm2: number): number {
  if (!Number.isFinite(sensorAreaCm2) || sensorAreaCm2 <= 0) return 0
  return valueKpa * KGF_CM2_PER_KPA * sensorAreaCm2
}

export function formatPressure(valueKpa: number, unit: PressureUnit): string {
  return `${number(convertPressure(valueKpa, unit), unit === 'KPA' ? 1 : 3)} ${pressureUnitLabel[unit]}`
}
